// Kairo theme JS — countdown timer + mobile nav toggle
document.addEventListener('DOMContentLoaded', function () {

  // Countdown timer (used by the stats/offer section)
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var hours = parseInt(el.dataset.hours || '1', 10);
    var minutes = parseInt(el.dataset.minutes || '0', 10);
    var seconds = parseInt(el.dataset.seconds || '0', 10);
    var target = new Date().getTime() + (hours * 3600 + minutes * 60 + seconds) * 1000;

    var hh = el.querySelector('[data-cd-hh]');
    var mm = el.querySelector('[data-cd-mm]');
    var ss = el.querySelector('[data-cd-ss]');

    function tick() {
      var now = new Date().getTime();
      var diff = Math.max(0, target - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hh) hh.textContent = String(h).padStart(2, '0');
      if (mm) mm.textContent = String(m).padStart(2, '0');
      if (ss) ss.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  // Mobile nav toggle
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Product page: swap main image when a thumbnail is clicked
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-product-main-image]');
      if (mainImg && thumb.dataset.fullSrc) {
        mainImg.src = thumb.dataset.fullSrc;
      }
      document.querySelectorAll('[data-product-thumb]').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // Ingredient "Key Studies" expand/collapse
  document.querySelectorAll('[data-key-studies-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.parentElement.querySelector('[data-key-studies-panel]');
      if (panel) {
        panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
      }
    });
  });
});
